import './MiniProduct.scss';
import Component from './MiniProduct.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
